export default [
    { 
        id: 151, 
        url: 'haro',
        name: 'Haro', 
        parent: 'floor-coverings',
        content: {
            pics: [
                '../assets/img/pics/haro/haro_1.jpg',
                '../assets/img/pics/haro/haro_2.jpg',
                '../assets/img/pics/haro/haro_3.jpg',
                '../assets/img/pics/haro/haro_4.jpg',
                '../assets/img/pics/haro/haro_5.jpg',
                '../assets/img/pics/haro/haro_6.jpg',
                '../assets/img/pics/haro/haro_7.jpg',
                '../assets/img/pics/haro/haro_8.jpg',
            ],
            title: 'HARO – вдохновение природой!',
            about: 'Бесконечные пески пустыни и мягко падающий снег, игра цветов и фактур – именно природа послужила главным вдохновителем для создания напольных покрытий HARO. Ведь не существует ничего более прекрасного и уникального, чем сама природа. Именно это и сделает ваш пол и интерьер поистине особенным!',
            website: 'https://www.haro.com'
        }
    },
    { 
        id: 152, 
        url: 'weitzer',
        name: 'Weitzer', 
        parent: 'floor-coverings',
        content: {
            pics: [
                '../assets/img/pics/weitzer/weitzer_1.jpg',
                '../assets/img/pics/weitzer/weitzer_2.jpg',
                '../assets/img/pics/weitzer/weitzer_3.jpg',
            ],
            title: 'Weitzer Parkett - паркет, который не требует ухода! Австрийское качество.',
            about: 'Пол самый большой по площади элемент интерьера Вашего дома. Поэтому важно, чтобы его внешний вид в комбинации с мебелью мог в полной мере стать симбиозом - и наша задача возложить к Вашим ногам самые красивые породы дерева!',
            website: 'https://www.weitzer-parkett.com'
        }
    },
    { 
        id: 153, 
        url: 'fogliedoro',
        name: 'Foglie Doro', 
        parent: 'floor-coverings',
        content: {
            pics: [
                '../assets/img/pics/fogliedoro/fogliedoro_1.jpg',
                '../assets/img/pics/fogliedoro/fogliedoro_2.jpg',
                '../assets/img/pics/fogliedoro/fogliedoro_3.jpg',
                '../assets/img/pics/fogliedoro/fogliedoro_4.jpg',
            ],
            title: 'Foglie d`Oro – дерево, которое создает в доме атмосферу комфорта и уюта!',
            about: 'Итальянский паркет этого бренда – это результат скрупулезной работы лучших мастеров в гармоничном сочетании с инновационными технологиями. Прямо под вашими ногами создаются неповторимые узоры, где трапеции и треугольники сливаются в гармоничный рисунок, органично вписываясь в любые интерьеры.',
            website: 'http://www.fogliedoroparquet.com'
        }
    },
    { 
        id: 154, 
        url: 'cpparquet',
        name: 'CP Parquet', 
        parent: 'floor-coverings',
        content: {
            pics: [
                '../assets/img/pics/cpparquet/cpparquet_1.jpg',
                '../assets/img/pics/cpparquet/cpparquet_2.jpg',
                '../assets/img/pics/cpparquet/cpparquet_3.jpg',
                '../assets/img/pics/cpparquet/cpparquet_4.jpg',
                '../assets/img/pics/cpparquet/cpparquet_5.jpg',
                '../assets/img/pics/cpparquet/cpparquet_6.jpg',
            ],
            title: 'CP Parquet – паркет с истинно итальянским характером!',
            about: 'За более чем 30-летнюю историю бренд CP Parquet сумел совершить настоящую модную революцию в мире эксклюзивных напольных покрытий. Основатели компания сделали ставку на природные материалы - дерево. И не ошиблись! Все коллекции словно бы пропитаны духом Италии, ее традициями и особым стилем.',
            website: 'https://www.cpparquet.it'
        }
    },
    { 
        id: '', 
        url: 'bertiparquet',
        name: 'Berti Parquet', 
        parent: 'hidden',
        content: {
            pics: [
                '../assets/img/pics/bertiparquet/bertiparquet_1.jpg',
                '../assets/img/pics/bertiparquet/bertiparquet_2.jpg',
                '../assets/img/pics/bertiparquet/bertiparquet_3.jpg',
                '../assets/img/pics/bertiparquet/bertiparquet_4.jpg',
            ],
            title: 'Berti Parquet – напольное покрытие королевских залов!',
            about: 'Некоторые вещи вне моды и времени. Именно к таким и относятся напольные покрытия бренда. Соединение разных пород дерева образует контрастные и действительно интересные узоры. Паркет Berti можно встретить в самых роскошных локациях и оформлениях, например, в королевском Виндзорском дворце.',
            website: 'https://www.berti.net'
        }
    }
]